export default __webpack_public_path__ + "static/media/loading_3.a603bd1a.jpg";